import {
  ESTADO_ORDEN,
  ESTADO_ORDEN_FAIL,
  ESTADO_ORDEN_SUCCESS,
  SET_ORDEN,
} from "../ActionTypes";

const orden = (state, { payload, type }) => {
  switch (type) {
    case SET_ORDEN:
      return {
        ...state,
        orden: {
          ...state.orden,
          error: false,
          data: payload,
        },
      };
    case ESTADO_ORDEN:
      return {
        ...state,
        orden: {
          ...state.orden,
          loading: true,
          error: false,
          estado: null,
        },
      };
    case ESTADO_ORDEN_SUCCESS:
      return {
        ...state,
        orden: {
          ...state.orden,
          loading: false,
          error: false,
          estado: payload,
        },
      };
    case ESTADO_ORDEN_FAIL:
      return {
        ...state,
        orden: {
          ...state.orden,
          loading: false,
          error: payload,
          estado: null,
        },
      };
   

    default:
      return state;
  }
};

export default orden;
